/*
 * XYNE Redesign — Shared scroll-reveal observer
 * One IntersectionObserver for the whole page. Replaces per-section inline
 * observer scripts. Loaded once via theme.liquid (deferred).
 */
(function () {
  'use strict';

  function init() {
    var els = document.querySelectorAll('.rd-reveal');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      // Older browsers — show everything, no animation
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -10% 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
